import { render, staticRenderFns } from "./VesselOverview.vue?vue&type=template&id=17dcfc9e&"
import script from "./VesselOverview.vue?vue&type=script&lang=js&"
export * from "./VesselOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports